"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { IoChevronDown } from "react-icons/io5";
import { MobileMenu } from "./MobileMenu";
export const Header = ({ lightHeader }) => {
	const [isSticky, setIsSticky] = useState(false);

	useEffect(() => {
		if (typeof window !== "undefined") {
			window.addEventListener("scroll", () =>
				setIsSticky(window.scrollY > 200)
			);
		}
	}, []);

	return (
		<header className={`border-b ${isSticky ? "sticky-header" : ""} ${!lightHeader ? "border-[#E7E7E7]" : "border-[#8C8C8C]"} ${lightHeader ? "text-white" : "text-text"}  absolute top-0 left-0 z-50 w-full`}>
			<div className="hp-container flex justify-between items-center py-2 xl:py-0">
				<Link href="/">
					{!lightHeader || isSticky ? (
						<Image alt="Hindustan Power logo" src="/logo.png" width={280} height={140} unoptimized className="-ml-3 h-auto w-[220px] lg:w-[200px] xl:w-[280px] object-contain" />
					) : (
						<Image alt="Hindustan Power logo" src="/logo-white.svg" width={280} height={140} unoptimized className="-ml-3 h-auto w-[220px] lg:w-[200px] xl:w-[280px]" />
					)}
				</Link>

				<div className={`menu font-medium gap-5 2xl:gap-7 items-center hidden xl:flex text-[14px] xl:text-[18px] `}>
					<div className="flex items-center gap-1 group relative py-6 cursor-pointer">Company
						<IoChevronDown className="mt-1" />
						<div className="hidden group-hover:flex flex-col absolute top-full text-text bg-white  w-40 px-4 py-6 gap-4 text-[14px] lg:text-[16px] leading-[18px] box-shadow rounded-[5px] font-medium">
							<Link href="/about" className="hover:text-red">About Us</Link>
							<Link href="/leadership" className="hover:text-red">Leadership</Link>
							<Link href="/corporate-governance" className="hover:text-red">Corporate Governance{" "}</Link>

							{/* <Link href="/sustainability" className="hover:text-red">Sustainability</Link>
							<Link href="/csr" className="hover:text-red">CSR</Link> */}
							{/* <Link href="/awards" className="hover:text-red">Awards</Link>  */}
						</div>
					</div>

					<div className="flex items-center gap-1 group relative py-6 cursor-pointer">Our Businesses
						<IoChevronDown className="mt-1" />
						<div className="hidden group-hover:flex flex-col absolute text-text top-full bg-white w-60 px-4 py-6 gap-4 text-[14px] lg:text-[16px] leading-[18px] box-shadow rounded-[5px] font-medium">
							<Link href="/business/thermal-power" className="hover:text-red">Transitional Energy</Link>
							<Link href="/business/renewable" className="hover:text-red">Renewable Energy</Link>
							<Link href="/business/mining" className="hover:text-red">Mining Operations</Link>
							<Link href="/business/biofuels" className="hover:text-red">Biofuels</Link>
							<Link href="/business/battery-storage" className="hover:text-red">Battery Storage</Link>
							<Link href="/business/critical-minerals" className="hover:text-red">Critical Minerals</Link>
						</div>
					</div>

					<div className="flex items-center gap-1 group relative py-6 cursor-pointer">Sustainability
						<IoChevronDown className="mt-1" />
						<div className="hidden group-hover:flex flex-col absolute text-text top-full bg-white w-56 px-4 py-6 gap-4 text-[14px] lg:text-[16px] leading-[18px] box-shadow rounded-[5px] font-medium">
							<Link href="/sustainability" className="hover:text-red">Environment</Link>
							<Link href="/csr" className="hover:text-red">Community &amp; CSR</Link>
							{/* <Link href="/statutory-disclosures" className="hover:text-red">Statutory Disclosures</Link> */}
						</div>
					</div>

					{/* <div className="flex items-center gap-1 group relative py-6 cursor-pointer">Our Businesses
						<IoChevronDown className="mt-1" />
						<div className="hidden group-hover:flex flex-col absolute text-text top-full bg-white  w-56 px-4 py-6 gap-4 text-[14px] lg:text-[16px] leading-[18px] box-shadow rounded-[5px] font-medium">
							<Link href="/business/thermal-power" className="hover:text-red">Transitional Energy</Link>
							<Link href="/business/renewable" className="hover:text-red">Renewable Energy</Link>
							<Link href="/business/mining" className="hover:text-red">Mining Operations</Link>
						</div>
					</div> */}

					<div className="flex items-center gap-1 group relative py-6 cursor-pointer">Media Center
						<IoChevronDown className="mt-1 " />
						<div className="hidden group-hover:flex flex-col absolute text-text top-full bg-white  w-44 px-4 py-6 gap-4 text-[14px] lg:text-[16px] leading-[18px] box-shadow rounded-[5px] font-medium">
							<Link href="/awards" className="hover:text-red">Award</Link>
							<Link href="/media-coverage" className="hover:text-red">Media Coverage</Link>
							<Link href="/news-release" className="hover:text-red">News Releases</Link>
							<Link href="/media-kit" className="hover:text-red">Media Kit</Link>
							<Link href="/thought-leadership" className="hover:text-red">Thought Leadership</Link>
						</div>
					</div>

					<Link href="/life-at-hindustan-power" className="py-6">Careers{" "}</Link>
					<Link href="/tenders" className="py-6">Tenders</Link>
					<Link href="/contact-us" className={`header-button ${lightHeader ? "bg-white text-black" : "bg-primary text-white"} py-2.5 px-5 rounded-[20px] inline-block font-bold`}>Contact</Link>
				</div>
				<MobileMenu lightHeader={lightHeader} isSticky={isSticky} />
			</div>
		</header>
	);
};
